import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

// 'metricCacheVersion' doc name mirrored in functions/src/onBonusDatasetCreated (via admin.firestore() calls)
const getMetricCacheVersionRef = ({ accountId }: { accountId: string }) => {
  return firebase
    .firestore()
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.METRIC_DEFINITIONS_COLLECTION)
    .doc('metricCacheVersion');
};

export default getMetricCacheVersionRef;
